import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";

export const Cinema = () => (
  <section id="cinema" className="relative overflow-hidden bg-ink py-24 lg:py-36">
    <div className="relative mx-auto max-w-6xl px-5 lg:px-10">
      <Reveal>
        <span className="text-[11px] font-medium uppercase tracking-[0.42em] text-gold">
          Sul set
        </span>
        <h2 className="mt-4 font-display text-4xl font-light leading-tight text-ivory lg:text-6xl">
          Partnership <span className="italic text-gold">Cinematografiche</span>
        </h2>
        <p className="mt-5 max-w-2xl text-base font-light leading-relaxed text-white/60">
          Brahma by Pómalab incontra il cinema: guarda il progetto "Dieci e Venticinque".
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-12 overflow-hidden rounded-[2rem] border border-gold/40 shadow-[0_40px_90px_rgba(0,0,0,0.45)]">
          <iframe
            data-testid="cinema-youtube-iframe"
            src="https://www.youtube-nocookie.com/embed/Ms3ntR2p7-0"
            title="Dieci e Venticinque — Brahma by Pómalab"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="aspect-video w-full"
          />
        </div>
        <a
          href="https://www.youtube.com/watch?v=Ms3ntR2p7-0"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cinema-youtube-link"
          className="mt-8 inline-flex items-center gap-2 rounded-full border border-gold/50 px-6 py-3 text-[11px] uppercase tracking-[0.22em] text-gold transition-colors duration-300 hover:bg-gold hover:text-ink"
        >
          Guarda su YouTube
          <ArrowUpRight className="h-3.5 w-3.5" />
        </a>
      </Reveal>
    </div>
  </section>
);
